import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

/**
 * This file is used for any duration related dayjs functions by leveraging the duration plugins
 *
 * @module dayjs-duration
 */

dayjs.extend(duration);

export default dayjs;
